import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { ValueConverterIcon } from "../icons";

export default {
  options: {
    group: "config",
    accessible: ({ user }) =>
      user.role === "admin" &&
      user.permissions.indexOf("value-converter/list") !== -1,
  },
  icon: ValueConverterIcon,
  list: List,
  edit: Edit,
  create: Create,
};
